"use client";

import { usePathname } from "next/navigation";

interface Props {
  className?: string;
}

/**
 * Footer-link naar /actievoorwaarden die de huidige page-slug als `?from=`
 * query meegeeft. Zo "springt de actie mee" — de terms-page resolved op
 * basis van de page waar bezoeker vandaan komt, niet altijd de root.
 *
 * Op /-zelf, /actievoorwaarden, of statische legal pages: gewoon /actievoorwaarden.
 */
export default function ActieVoorwaardenLink({ className }: Props) {
  const pathname = usePathname() ?? "/";
  // Strip trailing slash, leading slash → slug
  const slug = pathname.replace(/^\//, "").replace(/\/$/, "");
  // Skip wanneer we al op /actievoorwaarden zijn of op statisch / homepage
  const STATIC_PAGES = new Set([
    "",
    "actievoorwaarden",
    "privacy",
    "cookies",
    "brochure",
  ]);
  // Voor brochure/[token] paths: strip alles na de eerste segment
  const firstSegment = slug.split("/")[0] ?? "";
  const skipParam = STATIC_PAGES.has(firstSegment);

  const href = skipParam
    ? "/actievoorwaarden"
    : `/actievoorwaarden?from=${encodeURIComponent(slug)}`;

  return (
    <a href={href} className={className}>
      Actievoorwaarden
    </a>
  );
}
